import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { CompanyGroupListItem, ICompanyGroupListItem } from "./companyGroupListItem";

export interface ICompanyGroupListItems extends IListItems<ICompanyGroupListItem> {}

export class CompanyGroupListItems extends ListItems<CompanyGroupListItem> implements ICompanyGroupListItems {
    constructor();
    constructor(obj: ICompanyGroupListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, CompanyGroupListItem);
    }
}